import { ArrayHelper } from "@workspace/common";

const NORMAL = "normal";
const JSONB = "jsonb";

export const FILTER_LABELS = {
  dateRange: "Date Range",
  salesPerson: "Sales Person",
  recruiter: "Recruiter",
  client: "Client",
  country: "Country",
};

export const REPORT_MANDATORY_OPTIONS = [];

export const REPORT_INITIAL_OPTIONS = [
  {
    sortValue: "job_submission_data.jobId",
    label: "Pulse Job ID",
    value: "jobSubmissionData.jobId",
    sort: true,
    expand: true,
    sortType: JSONB,
  },
  {
    sortValue: "job_submission_data.jobTitle",
    label: "Job Title",
    value: "jobSubmissionData.jobTitle",
    sort: true,
    expand: true,
    sortType: JSONB,
  },
  {
    sortValue: "job_submission_data.jobType",
    label: "Job Type",
    value: "jobSubmissionData.jobType",
    sort: true,
    expand: true,
    sortType: JSONB,
    filterType: "custom",
    element: "custom",
  },
  {
    sortValue: "job_submission_data.jobStatus",
    label: "Job Status",
    value: "jobSubmissionData.jobStatus",
    sort: true,
    expand: true,
    sortType: JSONB,
    filterType: "custom",
    element: "custom",
  },
  {
    sortValue: "job.created_at",
    label: "Job Created Date",
    value: "createdAt",
    sort: true,
    expand: true,
    sortType: NORMAL,
    filterType: "custom",
    element: "custom",
  },
  {
    sortValue: "job_submission_data.dateOpen",
    label: "Ageing",
    value: "jobSubmissionData.dateOpen",
    sort: true,
    expand: true,
    sortType: JSONB,
  },
  {
    sortValue: "job_submission_data.accountName",
    label: "Account Name",
    value: "jobSubmissionData.accountName",
    sort: true,
    expand: true,
    sortType: JSONB,
    filterType: "custom",
    element: "custom",
  },
  {
    sortValue: "job_submission_data.accountType",
    label: "Account Type",
    value: "jobSubmissionData.accountType",
    sort: true,
    expand: true,
    sortType: JSONB,
    filterType: "custom",
    element: "custom",
  },
  {
    sortValue: "job_submission_data.accountOwner",
    label: "Account Owner",
    value: "jobSubmissionData.accountOwner",
    sort: true,
    expand: true,
    sortType: JSONB,
  },
  {
    sortValue: "job_submission_data.country",
    label: "Country",
    value: "jobSubmissionData.country",
    sort: true,
    expand: true,
    sortType: JSONB,
  },
  {
    sortValue: "job_submission_data.workLocation",
    label: "Work Location",
    value: "jobSubmissionData.workLocation",
    sort: true,
    expand: true,
    sortType: JSONB,
  },
  {
    sortValue: "job_submission_data.noofheadcounts",
    label: "No. Of Headcounts",
    value: "jobSubmissionData.noofheadcounts",
    sort: true,
    expand: true,
    sortType: JSONB,
  },
];

export const buildOptionsArray = (
  formSchema,
  valuePrefix = "",
  sortValuePrefix = ""
) => {
  const options = [];
  formSchema?.forEach((field) => {
    if (field?.name && field?.name !== "") {
      const data = {};
      data.label = formatString(field.name);
      data.value = valuePrefix + "." + field?.name;
      data.sortValue = sortValuePrefix + "." + field?.name;
      data.sort = true;
      data.sortType = "jsonb";
      data.dbDataType = "jsonb";
      options.push(data);
    }
  });
  return options;
};

function formatString(input) {
  // Remove asterisk if present
  input = input.replace("*", "");

  // Convert camelCase to space-separated words with proper capitalization
  let result = input
    .replace(/([a-z])([A-Z])/g, "$1 $2") // Add space between camelCase words
    .replace(/([A-Z])/g, " $1") // Add space before each capital letter
    .trim(); // Remove leading/trailing spaces

  // Capitalize the first letter of each word
  result = result
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

  return result;
}

const JOB_MAIN_FIELDS = [
  {
    label: "Created By",
    value: "createdByName",
    sort: true,
    sortValue: "createdByName",
  },
  {
    label: "Updated By",
    value: "updatedByName",
    sort: true,
    sortValue: "updatedByName",
  },
  {
    label: "Updated At",
    value: "updatedAt",
    sort: true,
    sortValue: "updated_at",
  },
  {
    label: "Created At",
    value: "createdAt",
    sort: true,
    sortValue: "created_at",
  },
  {
    label: "Recruiter",
    value: "users.first_name",
    sort: true,
    sortValue: "users.first_name",
    filterType: "custom",
    element: "custom",
  },
];

export const generateJobReportFields = (jobForm) => {
  const jobReportFields = [...REPORT_INITIAL_OPTIONS, ...JOB_MAIN_FIELDS];

  if (jobForm) {
    const jobOptions = buildOptionsArray(
      jobForm?.formSchema,
      "jobSubmissionData",
      "job_submission_data"
    );
    jobReportFields.push(...jobOptions);
  }

  // Remove duplicate value in the object of array. Keep the first
  const uniqueUniversalReportFields = jobReportFields.filter(
    (field, index, self) =>
      index === self.findIndex((t) => t.value === field.value)
  );

  ArrayHelper.sortArrayObjIcase(uniqueUniversalReportFields, "label");

  return uniqueUniversalReportFields;
};

// my array is a array of objects.
// I want to remove duplicates based on a key value
const removeDuplicatesKeepFirst = (arr, key) => {
  return [...new Map(arr.map((item) => [item[key], item])).values()];
};
